import { useContext, useState } from 'react';
import TrackingContext from './TrackingContext';

export const useTrackMounted = (componentName, trackArgs) => {
  const { track, isTrackingInUse } = useContext(TrackingContext);
  const [isMounted, setIsMounted] = useState(false);
  if (isTrackingInUse && !isMounted) {
    setIsMounted(true);
    track({
      type: 'mounted',
      component: componentName,
      ...trackArgs,
    });
  }
};
